define('js/de/initdata',[], function() {
    'use strict';

    return new Backbone.Model(window.initData);
});

